function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defaultBlack, defaultGreen, defaultGrey, defaultOrange, defaultRed } from "../../utils/colors";
export var buttonStyle = function buttonStyle(_ref) {
  var spacing = _ref.spacing;
  return {
    buttonSpan: {
      '& > :first-child': {
        marginRight: spacing(0.5)
      }
    },
    buttonColorDefault: {
      backgroundColor: "".concat(defaultGrey),
      color: 'white',
      '&:hover': {
        backgroundColor: defaultGrey
      }
    },
    buttonColorSuccess: {
      backgroundColor: "".concat(defaultGreen),
      color: 'white',
      '&:hover': {
        backgroundColor: defaultGreen
      }
    },
    buttonColorWarning: {
      backgroundColor: "".concat(defaultOrange),
      color: 'white',
      '&:hover': {
        backgroundColor: defaultOrange
      }
    },
    buttonColorError: {
      backgroundColor: "".concat(defaultRed),
      color: 'white',
      '&:hover': {
        backgroundColor: defaultRed
      }
    },
    buttonColorContrast: {
      backgroundColor: "".concat(defaultBlack),
      color: 'white',
      '&:hover': {
        backgroundColor: defaultBlack
      }
    }
  };
};
export function buttonClassNameDefinition(classes, margin, customVariant) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, classes.marginTop, margin), _defineProperty(_ref2, classes.buttonColorDefault, customVariant === 'default'), _defineProperty(_ref2, classes.buttonColorSuccess, customVariant === 'success'), _defineProperty(_ref2, classes.buttonColorWarning, customVariant === 'warning'), _defineProperty(_ref2, classes.buttonColorError, customVariant === 'error'), _defineProperty(_ref2, classes.buttonColorContrast, customVariant === 'contrast'), _ref2;
}